import SummaryComponent from 'components/number-porting/geographic-port/Summary'
import React from 'react'

function Summary() {
  return <SummaryComponent />
}

export default Summary
